import { render, staticRenderFns } from "./StartFinish.vue?vue&type=template&id=34c86da2&scoped=true&"
import script from "./StartFinish.vue?vue&type=script&lang=js&"
export * from "./StartFinish.vue?vue&type=script&lang=js&"
import style0 from "./StartFinish.vue?vue&type=style&index=0&id=34c86da2&scoped=true&lang=css&"
import style1 from "./StartFinish.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c86da2",
  null
  
)

export default component.exports